/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostAIEvaluationRunPathParams = NonNullable<operations['postAIEvaluationRun']['parameters']['path']>;

export type PostAIEvaluationRunRequestBody = OperationRequestBodyContent<operations['postAIEvaluationRun']>;

export interface Input extends PostAIEvaluationRunPathParams {
  apiVersion?: string;
  body: PostAIEvaluationRunRequestBody;
  header: NonNullable<operations['postAIEvaluationRun']['parameters']['header']>;
}

export async function postAIEvaluationRun(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projectKey}/ai/evaluations/{evaluationId}/runs', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
